import { render, staticRenderFns } from "./EventBookingComponent.vue?vue&type=template&id=2cf53b58"
import script from "./EventBookingComponent.vue?vue&type=script&lang=js"
export * from "./EventBookingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports